import { createPostAsyncSlice } from '@sonar-software/xuder';
import { postResendInvitation } from '@api';

export const securityInvitationsResendPostAsyncSlice = createPostAsyncSlice({
	name: 'SecurityInvitationsResend',
	receive: false,
	request: true,
	requestHandler: postResendInvitation
});
